

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { collection, query, where, getDocs, orderBy } from 'firebase/firestore';
// import { db } from '../../firebase/firebaseConfig';
// import './CategoriesSection.css';

// // Create base64 placeholder image for categories when image fails to load
// const PLACEHOLDER_IMAGE = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2YwZjBmMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMThweCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgZmlsbD0iIzk5OTk5OSI+Q2F0ZWdvcnkgSW1hZ2U8L3RleHQ+PC9zdmc+';

// const CategoriesSection = () => {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         setLoading(true);
//         console.log("Fetching categories...");
        
//         // Query for active categories, ordered by displayOrder
//         const categoriesQuery = query(
//           collection(db, 'categories'),
//           where('active', '==', true),
//           orderBy('displayOrder')
//         );
        
//         const querySnapshot = await getDocs(categoriesQuery);
        
//         if (querySnapshot.empty) {
//           console.log("No active categories found");
//           setCategories([]);
//           setLoading(false);
//           return;
//         }
        
//         // Convert query snapshot to array of categories
//         const categoriesData = querySnapshot.docs.map(doc => {
//           const data = doc.data();
          
//           return {
//             id: doc.id,
//             ...data,
//             // Set default image if not available
//             imageUrl: data.imageUrl || PLACEHOLDER_IMAGE
//           };
//         });
        
//         console.log("Found categories:", categoriesData);
//         setCategories(categoriesData);
//       } catch (err) {
//         console.error("Error fetching categories:", err);
//         // If there's an index error, fall back to a simpler query
//         if (err.message.includes('requires an index')) {
//           try {
//             console.log("Trying fallback query without ordering...");
//             const simpleQuery = query(
//               collection(db, 'categories'),
//               where('active', '==', true)
//             );
            
//             const snapshot = await getDocs(simpleQuery);
            
//             if (snapshot.empty) {
//               setCategories([]);
//             } else {
//               // Process and sort manually
//               const data = snapshot.docs.map(doc => ({
//                 id: doc.id,
//                 ...doc.data(),
//                 imageUrl: doc.data().imageUrl || PLACEHOLDER_IMAGE
//               }));
              
//               // Sort by displayOrder
//               const sortedData = data.sort((a, b) => 
//                 (a.displayOrder || 0) - (b.displayOrder || 0)
//               );
              
//               setCategories(sortedData);
//             }
//           } catch (fallbackErr) {
//             console.error("Fallback query failed:", fallbackErr);
//             setError(fallbackErr);
//           }
//         } else {
//           setError(err);
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCategories();
//   }, []);

//   // Show loading state
//   if (loading) {
//     return (
//       <section className="categories-section">
//         <div className="container">
//           <h2 className="section-title">All in one Robotics Platform</h2>
//           <div className="categories-loading">Loading categories...</div>
//         </div>
//       </section>
//     );
//   }

//   // Show error state
//   if (error) {
//     console.error("Categories error:", error);
//     return (
//       <section className="categories-section">
//         <div className="container">
//           <h2 className="section-title">All in one Robotics Platform</h2>
//           <div className="categories-error">Error loading categories. Please refresh the page.</div>
//         </div>
//       </section>
//     );
//   }

//   // No categories found
//   if (categories.length === 0) {
//     return null; // Don't display the section if no categories
//   }

//   // Fallback to static categories if needed for development/testing
//   const getFallbackCategories = () => [
//     {
//       id: 1,
//       name: 'Microcontrollers',
//       imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/1/19/Mck_glamor_320.jpg',
//       path: '/products?category=microcontrollers',
//       description: 'Arduino, ESP32, STM32 and more'
//     },
//     {
//       id: 2,
//       name: 'Single-Board Computers',
//       imageUrl: 'https://www.mouser.in/images/marketingid/2019/img/114369600.png?v=030124.1004',
//       path: '/products?category=single-board-computers',
//       description: 'Raspberry Pi, BeagleBone, Rock Pi'
//     },
//     {
//       id: 3,
//       name: 'Sensors',
//       imageUrl: 'https://www.sick.com/media/pim/9/79/179/IM0106179.png',
//       path: '/products?category=sensors',
//       description: 'Temperature, Motion, Light sensors'
//     },
//     {
//       id: 4,
//       name: 'Actuators',
//       imageUrl: 'https://www.ultralibrarian.com/wp-content/uploads/2023/11/One-sentence-or-less-description-of-image-with-a-potential-topic-found-in-the-blog.jpg',
//       path: '/products?category=actuators',
//       description: 'Servo motors, Stepper motors, Relays'
//     },
//     {
//       id: 5,
//       name: 'Motor Controllers',
//       imageUrl: 'https://www.orientalmotor.com/images/servo-motors/azx-series-servo-motor-top.jpg',
//       path: '/products?category=motor-controllers',
//       description: 'Motor drivers, Speed controllers'
//     },
//     {
//       id: 6,
//       name: 'Power Components',
//       imageUrl: 'https://thetech.com.vn/wp-content/uploads/2023/10/power-components-1.png',
//       path: '/products?category=power-components',
//       description: 'Power supplies, Batteries, Regulators'
//     }
//   ];

//   // Display categories from Firestore or fallback to static if there's an issue
//   const displayCategories = categories.length > 0 ? categories : getFallbackCategories();

//   return (
//     <section className="categories-section">
//       <div className="container">
//         <h2 className="section-title">All in one Robotics Platform</h2>
//         <div className="categories-grid">
//           {displayCategories.map(category => (
//             <Link to={category.path || '/'} key={category.id} className="category-card">
//               <div className="category-image-container">
//                 <img 
//                   src={category.imageUrl} 
//                   alt={category.name} 
//                   className="category-image"
//                   onError={(e) => {
//                     e.target.onerror = null; // Prevent infinite loop
//                     e.target.src = PLACEHOLDER_IMAGE;
//                   }}
//                 />
//                 <div className="category-overlay">
//                   <span className="category-explore">Explore</span>
//                 </div>
//               </div>
//               <div className="category-content">
//                 <h3 className="category-name">{category.name}</h3>
               
//               </div>
//             </Link>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CategoriesSection;


import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, where, getDocs, orderBy } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import './CategoriesSection.css';

// Create base64 placeholder image for categories when image fails to load
const PLACEHOLDER_IMAGE = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2YwZjBmMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMThweCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgZmlsbD0iIzk5OTk5OSI+Q2F0ZWdvcnkgSW1hZ2U8L3RleHQ+PC9zdmc+';

const CategoriesSection = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to generate a proper URL path for a category
  const generateCategoryPath = (category) => {
    // If category already has a path, use that
    if (category.path) {
      return category.path;
    }

    // Otherwise, generate a path based on the category name
    // Convert category name to lowercase and replace spaces with hyphens
    const categorySlug = category.name
      .toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, '')     // Remove any non-alphanumeric characters except hyphens
      .replace(/-+/g, '-')            // Replace multiple hyphens with a single hyphen
      .replace(/^-|-$/g, '');         // Remove hyphens at the beginning or end

    return `/products?category=${categorySlug}`;
  };

  const normalizeCategoryName = (name = '') => name.toLowerCase().trim();

  const orderCategoriesForDisplay = (categoryList = []) => {
    const firstPriority = ['3d printing', 'actuators', 'microcontrollers'];
    const lastPriority = ['power', 'power components', 'modules'];

    const getPriority = (name) => {
      const normalizedName = normalizeCategoryName(name);

      const firstIndex = firstPriority.findIndex((value) => normalizedName === value);
      if (firstIndex !== -1) {
        return firstIndex;
      }

      const lastIndex = lastPriority.findIndex((value) => normalizedName === value);
      if (lastIndex !== -1) {
        return 100 + lastIndex;
      }

      return 50;
    };

    return categoryList
      .map((category, index) => ({ category, index }))
      .sort((a, b) => {
        const priorityDiff = getPriority(a.category.name) - getPriority(b.category.name);
        if (priorityDiff !== 0) {
          return priorityDiff;
        }
        return a.index - b.index;
      })
      .map((item) => item.category);
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        console.log("Fetching categories...");
        
        // Query for active categories, ordered by displayOrder
        const categoriesQuery = query(
          collection(db, 'categories'),
          where('active', '==', true),
          orderBy('displayOrder')
        );
        
        const querySnapshot = await getDocs(categoriesQuery);
        
        if (querySnapshot.empty) {
          console.log("No active categories found");
          setCategories([]);
          setLoading(false);
          return;
        }
        
        // Convert query snapshot to array of categories
        const categoriesData = querySnapshot.docs.map(doc => {
          const data = doc.data();
          
          // Create category object with required properties
          const category = {
            id: doc.id,
            ...data,
            // Set default image if not available
            imageUrl: data.imageUrl || PLACEHOLDER_IMAGE
          };
          
          // Generate path for this category if it doesn't have one
          category.path = generateCategoryPath(category);
          
          return category;
        });
        
        console.log("Found categories:", categoriesData);
        setCategories(categoriesData);
      } catch (err) {
        console.error("Error fetching categories:", err);
        // If there's an index error, fall back to a simpler query
        if (err.message.includes('requires an index')) {
          try {
            console.log("Trying fallback query without ordering...");
            const simpleQuery = query(
              collection(db, 'categories'),
              where('active', '==', true)
            );
            
            const snapshot = await getDocs(simpleQuery);
            
            if (snapshot.empty) {
              setCategories([]);
            } else {
              // Process and sort manually
              const data = snapshot.docs.map(doc => {
                const categoryData = doc.data();
                const category = {
                  id: doc.id,
                  ...categoryData,
                  imageUrl: categoryData.imageUrl || PLACEHOLDER_IMAGE
                };
                
                // Generate path for this category
                category.path = generateCategoryPath(category);
                
                return category;
              });
              
              // Sort by displayOrder
              const sortedData = data.sort((a, b) => 
                (a.displayOrder || 0) - (b.displayOrder || 0)
              );
              
              setCategories(sortedData);
            }
          } catch (fallbackErr) {
            console.error("Fallback query failed:", fallbackErr);
            setError(fallbackErr);
          }
        } else {
          setError(err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <section className="categories-section">
        <div className="container">
          <div className="categories-heading-wrapper">
            <span className="categories-badge">Explore</span>
            <h2 className="categories-heading">All in one Robotics Platform</h2>
            <div className="categories-heading-accent"></div>
          </div>
          <div className="categories-loading">Loading categories...</div>
        </div>
      </section>
    );
  }

  // Show error state
  if (error) {
    console.error("Categories error:", error);
    return (
      <section className="categories-section">
        <div className="container">
          <div className="categories-heading-wrapper">
            <span className="categories-badge">Explore</span>
            <h2 className="categories-heading">All in one Robotics Platform</h2>
            <div className="categories-heading-accent"></div>
          </div>
          <div className="categories-error">Error loading categories. Please refresh the page.</div>
        </div>
      </section>
    );
  }

  // No categories found
  if (categories.length === 0) {
    return null; // Don't display the section if no categories
  }

  // Fallback to static categories if needed for development/testing
  const getFallbackCategories = () => [
    {
      id: 1,
      name: '3D Printing',
      imageUrl: 'https://www.3dnatives.com/en/wp-content/uploads/sites/2/3Dprinter-hero.jpg',
      path: '/products?category=3d-printing',
      description: '3D Printers, Filaments, Accessories'
    },
    {
      id: 2,
      name: 'Actuators',
      imageUrl: 'https://www.ultralibrarian.com/wp-content/uploads/2023/11/One-sentence-or-less-description-of-image-with-a-potential-topic-found-in-the-blog.jpg',
      path: '/products?category=actuators',
      description: 'Servo motors, Stepper motors, Relays'
    },
    {
      id: 3,
      name: 'Microcontrollers',
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/1/19/Mck_glamor_320.jpg',
      path: '/products?category=microcontrollers',
      description: 'Arduino, ESP32, STM32 and more'
    },
    {
      id: 4,
      name: 'Single-Board Computers',
      imageUrl: 'https://www.mouser.in/images/marketingid/2019/img/114369600.png?v=030124.1004',
      path: '/products?category=single-board-computers',
      description: 'Raspberry Pi, BeagleBone, Rock Pi'
    },
    {
      id: 5,
      name: 'Sensors',
      imageUrl: 'https://www.sick.com/media/pim/9/79/179/IM0106179.png',
      path: '/products?category=sensors',
      description: 'Temperature, Motion, Light sensors'
    },
    {
      id: 6,
      name: 'Motor Controllers',
      imageUrl: 'https://www.orientalmotor.com/images/servo-motors/azx-series-servo-motor-top.jpg',
      path: '/products?category=motor-controllers',
      description: 'Motor drivers, Speed controllers'
    },
    {
      id: 7,
      name: 'Power Components',
      imageUrl: 'https://thetech.com.vn/wp-content/uploads/2023/10/power-components-1.png',
      path: '/products?category=power-components',
      description: 'Power supplies, Batteries, Regulators'
    },
    {
      id: 8,
      name: 'Modules',
      imageUrl: 'https://www.mouser.in/images/marketingid/2019/img/114369600.png?v=030124.1004',
      path: '/products?category=modules',
      description: 'Communication, Display, Sensor Modules'
    }
  ];

  // Display categories from Firestore or fallback to static if there's an issue
  const displayCategories = orderCategoriesForDisplay(
    categories.length > 0 ? categories : getFallbackCategories()
  );

  return (
    <section className="categories-section">
      <div className="container">
        <div className="categories-heading-wrapper">
          <span className="categories-badge"> Explore Categories</span>
          <h2 className="categories-heading">All in one <span>Robotics</span> Platform</h2>
          <p className="categories-subtext">Browse our wide range of components, modules and tools</p>
          <div className="categories-heading-accent"></div>
        </div>
        <div className="categories-grid">
          {displayCategories.map(category => (
            <Link 
              to={category.path || '/products'} 
              key={category.id} 
              className="category-card"
              aria-label={`Browse ${category.name} category`}
            >
              <div className="category-image-container">
                <img 
                  src={category.imageUrl} 
                  alt={category.name} 
                  className="category-image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = PLACEHOLDER_IMAGE;
                  }}
                />
              </div>
              <div className="category-content">
                <h3 className="category-name">{category.name}</h3>
                <div className="category-arrow">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;